/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/team.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Team
 */
export interface Team {
    /**
     * @generated from protobuf field: optional string team_id = 1;
     */
    team_id?: string;
    /**
     * @generated from protobuf field: optional string team_name = 2;
     */
    team_name?: string;
    /**
     * @generated from protobuf field: optional string away_team_id = 3;
     */
    away_team_id?: string;
    /**
     * @generated from protobuf field: optional string home_team_id = 4;
     */
    home_team_id?: string;
    /**
     * @generated from protobuf field: optional string away_team_name = 5;
     */
    away_team_name?: string;
    /**
     * @generated from protobuf field: optional string home_team_name = 6;
     */
    home_team_name?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Team$Type extends MessageType<Team> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Team", [
            { no: 1, name: "team_id", kind: "scalar", localName: "team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Team ID for Program Type Match that have teams." } },
            { no: 2, name: "team_name", kind: "scalar", localName: "team_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ABC", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Team Name for Program Type Match that have teams." } },
            { no: 3, name: "away_team_id", kind: "scalar", localName: "away_team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Away Team ID for Program Type Match or Other." } },
            { no: 4, name: "home_team_id", kind: "scalar", localName: "home_team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Home Team ID for Program Type Match or Other." } },
            { no: 5, name: "away_team_name", kind: "scalar", localName: "away_team_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ABC", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Away Team Name for Program Type Match or Other." } },
            { no: 6, name: "home_team_name", kind: "scalar", localName: "home_team_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ABC", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Home Team Name for Program Type Match or Other." } }
        ]);
    }
    create(value?: PartialMessage<Team>): Team {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Team>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Team): Team {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string team_id */ 1:
                    message.team_id = reader.string();
                    break;
                case /* optional string team_name */ 2:
                    message.team_name = reader.string();
                    break;
                case /* optional string away_team_id */ 3:
                    message.away_team_id = reader.string();
                    break;
                case /* optional string home_team_id */ 4:
                    message.home_team_id = reader.string();
                    break;
                case /* optional string away_team_name */ 5:
                    message.away_team_name = reader.string();
                    break;
                case /* optional string home_team_name */ 6:
                    message.home_team_name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Team, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string team_id = 1; */
        if (message.team_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.team_id);
        /* optional string team_name = 2; */
        if (message.team_name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.team_name);
        /* optional string away_team_id = 3; */
        if (message.away_team_id !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.away_team_id);
        /* optional string home_team_id = 4; */
        if (message.home_team_id !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.home_team_id);
        /* optional string away_team_name = 5; */
        if (message.away_team_name !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.away_team_name);
        /* optional string home_team_name = 6; */
        if (message.home_team_name !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.home_team_name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Team
 */
export const Team = new Team$Type();
